import { type Kpi } from "@/types/proto/exabel/kpi/kpi_messages";

type KpiMonitoringUrlState = {
  selected?: Kpi;
};

const stateToParams = (state: KpiMonitoringUrlState) => {
  const structuredKpi = state.selected?.structuredKpi;
  if (!structuredKpi) return undefined;
  const searchParams = new URLSearchParams({
    kpi_type: structuredKpi.type || "",
    kpi_value: structuredKpi.value || "",
    kpi_freq: structuredKpi.freq || "",
    kpi_display_name: structuredKpi.displayName || "",
  });
  return searchParams.toString();
};

export { stateToParams };
